export default function (initialDataInteractor, questionnaireId, newTitle) {
  initialDataInteractor.data.questionnaires
    .find(q => q.id == questionnaireId)
    .name = newTitle;
}